import { Component, StrictMode, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

class AppErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (this.state.failed) {
      return <main className="app-loading"><strong>工作台遇到了意外问题</strong><small>本机未保存草稿仍会保留，重新载入后可继续处理。</small><button className="primary-button" onClick={() => window.location.reload()}>重新载入</button></main>;
    }
    return this.props.children;
  }
}

createRoot(document.getElementById("root")!).render(<StrictMode><AppErrorBoundary><App /></AppErrorBoundary></StrictMode>);
